import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function AccordionItem({
  question,
  answer,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border border-[rgba(0,0,0,0.08)] rounded-2xl mb-4 overflow-hidden bg-white hover:border-[rgba(29,78,216,0.3)] transition-colors duration-300" data-id="element-32">
      <button className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" onClick={onClick} data-id="element-33">
        <span className="font-['Montserrat'] text-[18px] font-bold text-[#09111F] pr-8" data-id="element-34">
          {question}
        </span>
        <div className={`w-8 h-8 rounded-full bg-[#F1F5F9] flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 bg-[#EFF6FF] text-[#1D4ED8]' : 'text-[#6B7280]'}`} data-id="element-35">
          <ChevronDown size={20} data-id="element-36" />
        </div>
      </button>
      <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-37">
        <p className="font-['Inter'] text-[17px] font-light text-[#4B5563] leading-[1.7]" data-id="element-38">
          {answer}
        </p>
      </div>
    </div>;
}
interface AccordionProps {
  items: {
    question: string;
    answer: string;
  }[];
}
export function Accordion({
  items
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="w-full max-w-[800px] mx-auto" data-id="element-39">
      {items.map((item, index) => <AccordionItem key={index} question={item.question} answer={item.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-40" />)}
    </div>;
}